import { useTranslation } from 'react-i18next';
import { RouterLink } from '@/common/components/RouterLink/RouterLink';
import { ROUTES } from '@/common/constants/routes';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { ISchoolNetworkButtonClickTraits } from '@/common/types/tracking';
import { Button, IconSchool } from '@coverflex-tech/hypernova';
import { css } from './SchoolsNetworkLink.css';

interface IProps {
  context: ISchoolNetworkButtonClickTraits['context'];
}
export const SchoolsNetworkLink = ({ context }: IProps) => {
  const { t } = useTranslation();
  return (
    <RouterLink
      href={ROUTES.SCHOOLS_NETWORK}
      className={css.host}
      onPress={() => {
        AnalyticsService.trackCustomEvent('school_network_button_clicked', {
          context,
        });
      }}
    >
      <Button variant="info" icon={<IconSchool />} presentational>
        {t('dashboard.childcare_voucher.schools_network.label')}
      </Button>
    </RouterLink>
  );
};
